import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
    redirect: "home",//设置重定向
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import(/* webpackChunkName: "goods" */ '../views/Home.vue'),
        meta: {
          title: '斯拓课堂−湖北专升本斯拓课堂_湖北专升本_武汉专升本_湖北专升本培训_湖北专升本英语_湖北专升本医学_湖北斯拓专升本',
          content: {
            keywords: '湖北斯拓专升本,湖北专升本,武汉专升本,斯拓课堂，斯拓网校,湖北专升本英语，湖北专升本辅导,湖北教育培训,你本有才寄宿升本集训营，湖北普通专升本,湖北统招专升本,湖北普通专升本培训',
            description: '湖北斯拓专升本，专注湖北专升本辅导多年，斯拓专升本集训营让湖北专升本学子，全程感受全日制、封闭式、高三式、沉浸式，吃住学一体化的学习环境，为湖北专升本学子提供一站式服务，服务热线:027-87688455。'
          }
        }
      },
      {
        path: 'curriculumsTable',
        name: 'curriculumsTable',
        component: () => import(/* webpackChunkName: "goods" */ '../views/Course/CurriculumsTable.vue'),
        meta: {
          title: '湖北专升本斯拓课堂_湖北专升本斯拓网校_你本有才集训营_湖北斯拓专升本−斯拓课堂',
          content: {
            keywords: '湖北斯拓专升本,斯拓课堂，斯拓网校,湖北专升本,武汉专升本,湖北专升本英语，湖北医学专升本,斯拓专升本辅导,你本有才寄宿升本集训营,湖北普通专升本,湖北统招专升本,湖北普通专升本培训',
            description: '湖北斯拓专升本专注湖北专升本辅导多年，斯拓专升本集训营让湖北专升本学子，全程感受全日制、封闭式、高三式、沉浸式，吃住学一体化的学习环境，为湖北专升本学子提供一站式服务。'
          }
        }
      },
      {
        path: 'newsBulletin',
        name: 'newsBulletin',
        component: () => import(/* webpackChunkName: "goods" */ '../views/Article/NewsBulletin.vue'),
        meta: {
          title: '湖北专升本斯拓课堂_新闻公告_升本指南_湖北专升本政策新闻_湖北专升本招生简章_湖北专升本考试大纲_湖北斯拓专升本−斯拓课堂',
          content: {
            keywords: '湖北斯拓专升本,斯拓课堂，斯拓网校,湖北专升本,武汉专升本,湖北专升本英语，湖北医学专升本,斯拓专升本辅导,你本有才寄宿升本集训营,湖北普通专升本,湖北统招专升本,湖北普通专升本培训',
            description: '湖北斯拓专升本专注湖北专升本辅导多年，斯拓专升本集训营让湖北专升本学子，全程感受全日制、封闭式、高三式、沉浸式，吃住学一体化的学习环境，为湖北专升本学子提供一站式服务。'
          }
        }
      },
      {
        path: 'newsDetails',
        name: 'newsDetails',
        component: () => import(/* webpackChunkName: "goods" */ '../views/Article/NewsDetails.vue'),
        meta: {
          title: '斯拓课堂',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      {
        path: 'usersCenter',
        name: 'usersCenter',
        component: () => import(/* webpackChunkName: "goods" */ '../views/UsersCenter/UsersCenter.vue'),
        children: [
          {
            path: 'myCourse',
            name: 'myCourse',
            component: () => import(/* webpackChunkName: "goods" */ '../views/UsersCenter/MyCourse.vue'),
            meta: {
              title: '我的课程-斯拓课堂',
              content: {
                keywords: '',
                description: ''
              }
            }
          },
          {
            path: 'myClassSchedule',
            name: 'myClassSchedule',
            component: () => import(/* webpackChunkName: "goods" */ '../views/UsersCenter/MyClassSchedule.vue'),
            meta: {
              title: '我的课程表-斯拓课堂',
              content: {
                keywords: '',
                description: ''
              }
            }
          },
          {
            path: 'myCollectClasses',
            name: 'myCollectClasses',
            component: () => import(/* webpackChunkName: "goods" */ '../views/UsersCenter/MyCollectClasses.vue'),
            meta: {
              title: '我的收藏-斯拓课堂',
              content: {
                keywords: '',
                description: ''
              }
            }
          },
          {
            path: 'myTiku',
            name: 'myTiku',
            component: () => import(/* webpackChunkName: "goods" */ '../views/UsersCenter/MyTiku.vue'),
            meta: {
              title: '我的收藏-斯拓课堂',
              content: {
                keywords: '',
                description: ''
              }
            }
          },
          {
            path: 'myExam',
            name: 'myExam',
            component: () => import(/* webpackChunkName: "goods" */ '../views/UsersCenter/MyExam.vue'),
            meta: {
              title: '我的考试-斯拓课堂',
              content: {
                keywords: '',
                description: ''
              }
            }
          },
          {
            path: 'myPoints',
            name: 'myPoints',
            component: () => import(/* webpackChunkName: "goods" */ '../views/UsersCenter/MyPoints.vue'),
            meta: {
              title: '我的积分-斯拓课堂',
              content: {
                keywords: '',
                description: ''
              }
            }
          },
          {
            path: 'myDiscountCoupon',
            name: 'myDiscountCoupon',
            component: () => import(/* webpackChunkName: "goods" */ '../views/UsersCenter/MyDiscountCoupon.vue'),
            meta: {
              title: '我的优惠券-斯拓课堂',
              content: {
                keywords: '',
                description: ''
              }
            }
          },
          {
            path: 'myMessage',
            name: 'myMessage',
            component: () => import(/* webpackChunkName: "goods" */ '../views/UsersCenter/MyMessage.vue'),
            meta: {
              title: '我的消息-斯拓课堂',
              content: {
                keywords: '',
                description: ''
              }
            }
          },
          {
            path: 'myOrder',
            name: 'myOrder',
            component: () => import(/* webpackChunkName: "goods" */ '../views/UsersCenter/MyOrder.vue'),
            meta: {
              title: '我的订单-斯拓课堂',
              content: {
                keywords: '',
                description: ''
              }
            }
          },
          {
            path: 'myTrainingCamp',
            name: 'myTrainingCamp',
            component: () => import(/* webpackChunkName: "goods" */ '../views/UsersCenter/MyTrainingCamp/MyTrainingCamp.vue'),
            meta: {
              title: '我的集训营-斯拓课堂',
              content: {
                keywords: '',
                description: ''
              }
            },
            children: [
              {
                path: 'myClass',
                name: 'myClass',
                component: () => import(/* webpackChunkName: "goods" */ '../views/UsersCenter/MyTrainingCamp/MyClass.vue'),
                meta: {
                  title: '我的班级-斯拓课堂',
                  content: {
                    keywords: '',
                    description: ''
                  }
                }
              },
              {
                path: 'myDormitory',
                name: 'myDormitory',
                component: () => import(/* webpackChunkName: "goods" */ '../views/UsersCenter/MyTrainingCamp/MyDormitory.vue'),
                meta: {
                  title: '我的宿舍-斯拓课堂',
                  content: {
                    keywords: '',
                    description: ''
                  }
                }
              },
              {
                path: 'myExamination',
                name: 'myExamination',
                component: () => import(/* webpackChunkName: "goods" */ '../views/UsersCenter/MyTrainingCamp/MyExamination.vue'),
                meta: {
                  title: '我的考试-斯拓课堂',
                  content: {
                    keywords: '',
                    description: ''
                  }
                }
              },
              {
                path: 'myClassSchedules',
                name: 'myClassSchedules',
                component: () => import(/* webpackChunkName: "goods" */ '../views/UsersCenter/MyTrainingCamp/MyClassSchedule.vue'),
                meta: {
                  title: '我的课程表-斯拓课堂',
                  content: {
                    keywords: '',
                    description: ''
                  }
                }
              },
            ]
          },
        ]
      },
      {
        path: 'userConfig',
        name: 'userConfig',
        component: () => import(/* webpackChunkName: "goods" */ '../views/UserConfig/UserConfig.vue'),
        children: [
          {
            path: 'showInfo',
            name: 'showInfo',
            component: () => import(/* webpackChunkName: "goods" */ '../views/UserConfig/ShowInfo.vue'),
            meta: {
              title: '账号信息-斯拓课堂',
              content: {
                keywords: '',
                description: ''
              }
            }
          },
          {
            path: 'showVipInfo',
            name: 'showVipInfo',
            component: () => import(/* webpackChunkName: "goods" */ '../views/UserConfig/ShowVipInfo.vue'),
            meta: {
              title: '个人资料-斯拓课堂',
              content: {
                keywords: '',
                description: ''
              }
            }
          },
          {
            path: 'toHeadPic',
            name: 'toHeadPic',
            component: () => import(/* webpackChunkName: "goods" */ '../views/UserConfig/ToHeadPic.vue'),
            meta: {
              title: '设置头像-斯拓课堂',
              content: {
                keywords: '',
                description: ''
              }
            }
          },
          {
            path: 'toUpdatePwd',
            name: 'toUpdatePwd',
            component: () => import(/* webpackChunkName: "goods" */ '../views/UserConfig/ToUpdatePwd.vue'),
            meta: {
              title: '修改密码-斯拓课堂',
              content: {
                keywords: '',
                description: ''
              }
            }
          },
        ]
      },
      {
        path: 'userAgreement',
        name: 'userAgreement',
        component: () => import(/* webpackChunkName: "goods" */ '../views/User/UserAgreement.vue'),
        meta: {
          title: '用户协议',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      {
        path: 'userPrivacy',
        name: 'userPrivacy',
        component: () => import(/* webpackChunkName: "goods" */ '../views/User/UserPrivacy.vue'),
        meta: {
          title: '隐私政策',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      {
        path: 'schoolList',
        name: 'schoolList',
        component: () => import(/* webpackChunkName: "goods" */ '../views/Academy/School.vue'),
        meta: {
          title: '湖北专升本斯拓课堂_湖北专升本院校规划_湖北专升本院校选择_湖北专升本专业选择_湖北斯拓专升本−斯拓课堂',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      {
        path: 'schoolDetails',
        name: 'schoolDetails',
        component: () => import(/* webpackChunkName: "goods" */ '../views/Academy/SchoolDetails.vue'),
        meta: {
          title: '湖北专升本斯拓课堂_湖北专升本院校规划_湖北专升本院校选择_湖北专升本专业选择_湖北斯拓专升本−斯拓课堂',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      {
        path: 'majorDetails',
        name: 'majorDetails',
        component: () => import(/* webpackChunkName: "goods" */ '../views/Academy/MajorDetails.vue'),
        meta: {
          title: '专业详情−斯拓课堂',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      {
        path: 'teachers',
        name: 'teachers',
        component: () => import(/* webpackChunkName: "goods" */ '../views/Teachers/Teachers.vue'),
        meta: {
          title: '名师专题−斯拓课堂',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      {
        path: 'teachersDetails',
        name: 'teachersDetails',
        component: () => import(/* webpackChunkName: "goods" */ '../views/Teachers/TeachersDetails.vue'),
        meta: {
          title: '名师−斯拓课堂',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      {
        path: 'ranking',
        name: 'ranking',
        component: () => import(/* webpackChunkName: "goods" */ '../views/Ranking.vue'),
        meta: {
          title: '湖北专升本斯拓课堂_湖北专升本晒分_湖北斯拓专升本−斯拓课堂',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      {
        path: 'courseDetails',
        name: 'courseDetails',
        component: () => import(/* webpackChunkName: "goods" */ '../views/Course/CourseDetails.vue'),
        meta: {
          title: '课程详情−斯拓课堂',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      {
        path: 'courseAudition',
        name: 'courseAudition',
        component: () => import(/* webpackChunkName: "goods" */ '../views/Course/CourseAudition.vue'),
        meta: {
          title: '课程试听−斯拓课堂',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      {
        path: 'videoPlaying',
        name: 'videoPlaying',
        component: () => import(/* webpackChunkName: "goods" */ '../views/Course/VideoPlaying.vue'),
        meta: {
          title: '课程学习−斯拓课堂',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      {
        path: 'questionbank',
        name: 'questionbank',
        component: () => import(/* webpackChunkName: "goods" */ '../views/Onlinestudy/Questionbank.vue'),
        meta: {
          title: '题库−斯拓课堂',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      {
        path: 'tikuDetail',
        name: 'tikuDetail',
        component: () => import(/* webpackChunkName: "goods" */ '../views/Onlinestudy/TikuDetail.vue'),
        meta: {
          title: '题详情−斯拓课堂',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      {
        path: 'appStore',
        name: 'appStore',
        component: () => import(/* webpackChunkName: "goods" */ '../views/AppStore.vue'),
        meta: {
          title: 'app下载−斯拓课堂',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      {
        path: 'payOrder',
        name: 'payOrder',
        component: () => import(/* webpackChunkName: "goods" */ '../views/PayOrder.vue'),
        meta: {
          title: '支付−斯拓课堂',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
      {
        path: 'initPotocolDetail',
        name: 'initPotocolDetail',
        component: () => import(/* webpackChunkName: "goods" */ '../views/Course/InitPotocolDetail.vue'),
        meta: {
          title: '课程协议−斯拓课堂',
          content: {
            keywords: '',
            description: ''
          }
        }
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  //    路由发生变化改变description和keyword
  if (to.meta.content) {
    const head = document.getElementsByTagName('head')
    const meta = document.createElement('meta')
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content
    head[0].appendChild(meta)
  }
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})


export default router
